import type { RegenerateAffectedDto, WhereUsedDto, WhereUsedTarget } from '@pb/shared';
import { get, post } from './client';

export const getWhereUsed = (target: WhereUsedTarget, id: number) => get<WhereUsedDto>(`/where-used/${target}/${id}`);
export const regenerateAffected = (target: WhereUsedTarget, id: number) =>
  post<RegenerateAffectedDto>(`/regenerate-affected/${target}/${id}`, {});
